import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { createTheme, StyledEngineProvider, ThemeProvider as ThemeProvider$1, useTheme as useTheme$1 } from '@mui/material/styles';
import Baseline from '@mui/material/CssBaseline';
import ScopedBaseline from '@mui/material/ScopedCssBaseline';
import { useMemo } from 'react';
import { accordionClasses } from '@mui/material/Accordion';
import { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import { alertClasses } from '@mui/material/Alert';
import { alertTitleClasses } from '@mui/material/AlertTitle';
import { lighten, darken } from '@mui/system';
import { inputBaseClasses } from '@mui/material/InputBase';
import { checkboxClasses } from '@mui/material/Checkbox';
import SvgIcon from '@mui/material/SvgIcon';
import { formLabelClasses } from '@mui/material/FormLabel';
import { formControlLabelClasses } from '@mui/material/FormControlLabel';
import { inputLabelClasses } from '@mui/material/InputLabel';
import { touchRippleClasses, listItemButtonClasses, listItemTextClasses } from '@mui/material';
import { menuItemClasses } from '@mui/material/MenuItem';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { radioClasses } from '@mui/material/Radio';
import IconButton from '@mui/material/IconButton';
import ExpandSectionIcon from '@mui/icons-material/ExpandMoreSharp';
import CalendarIcon from '@mui/icons-material/DateRangeSharp';
import ClockIcon from '@mui/icons-material/ScheduleSharp';
import ChevronDownIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import { css, Global } from '@emotion/react';
import { typographyClasses } from '@mui/material/Typography';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$b =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$6 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$5 = fails$6;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$5(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var fails$4 = fails$6;
var classof = classofRaw;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$4(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$3 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$9 = function (argument) {
  return typeof argument === 'function';
};

var isCallable$8 = isCallable$9;

var isObject$5 = function (it) {
  return typeof it === 'object' ? it !== null : isCallable$8(it);
};

var global$a = global$b;
var isCallable$7 = isCallable$9;

var aFunction = function (argument) {
  return isCallable$7(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$a[namespace]) : global$a[namespace] && global$a[namespace][method];
};

var getBuiltIn$2 = getBuiltIn$3;

var engineUserAgent = getBuiltIn$2('navigator', 'userAgent') || '';

var global$9 = global$b;
var userAgent = engineUserAgent;

var process = global$9.process;
var Deno = global$9.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$3 = fails$6;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$3(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var isCallable$6 = isCallable$9;
var getBuiltIn$1 = getBuiltIn$3;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$1('Symbol');
  return isCallable$6($Symbol) && Object(it) instanceof $Symbol;
};

var tryToString$1 = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$5 = isCallable$9;
var tryToString = tryToString$1;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$5(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};

var isCallable$4 = isCallable$9;
var isObject$4 = isObject$5;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$4(fn = input.toString) && !isObject$4(val = fn.call(input))) return val;
  if (isCallable$4(fn = input.valueOf) && !isObject$4(val = fn.call(input))) return val;
  if (pref !== 'string' && isCallable$4(fn = input.toString) && !isObject$4(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$8 = global$b;

var setGlobal$3 = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global$8, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$8[key] = value;
  } return value;
};

var global$7 = global$b;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$7[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.1',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

var requireObjectCoercible = requireObjectCoercible$2;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$2 = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var toObject$1 = toObject$2;

var hasOwnProperty = {}.hasOwnProperty;

var has$7 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject$1(it), key);
};

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var global$6 = global$b;
var shared$2 = shared$3.exports;
var has$6 = has$7;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$6.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$1 = function (name) {
  if (!has$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has$6(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var isObject$3 = isObject$5;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol = wellKnownSymbol$1;

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$3(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject$3(result) || isSymbol$1(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};

var global$5 = global$b;
var isObject$2 = isObject$5;

var document = global$5.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$2(document) && isObject$2(document.createElement);

var documentCreateElement = function (it) {
  return EXISTS$1 ? document.createElement(it) : {};
};

var DESCRIPTORS$5 = descriptors;
var fails$2 = fails$6;
var createElement = documentCreateElement;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$5 && !fails$2(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$4 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$2 = toIndexedObject$3;
var toPropertyKey$1 = toPropertyKey$2;
var has$5 = has$7;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$4 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$5(O, P)) return createPropertyDescriptor$1(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$1 = isObject$5;

// `Assert: Type(argument) is Object`
var anObject$2 = function (argument) {
  if (isObject$1(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};

var DESCRIPTORS$3 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$1 = anObject$2;
var toPropertyKey = toPropertyKey$2;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$3 ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey(P);
  anObject$1(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$2 = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$3 = DESCRIPTORS$2 ? function (object, key, value) {
  return definePropertyModule$1.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$1 = {exports: {}};

var isCallable$3 = isCallable$9;
var store$1 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$3(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var global$4 = global$b;
var isCallable$2 = isCallable$9;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$4.WeakMap;

var nativeWeakMap = isCallable$2(WeakMap$1) && /native code/.test(inspectSource$1(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$3 = global$b;
var isObject = isObject$5;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$3;
var objectHas = has$7;
var shared = sharedStore;
var sharedKey = sharedKey$1;
var hiddenKeys$2 = hiddenKeys$3;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global$3.WeakMap;
var set, get, has$4;

var enforce = function (it) {
  return has$4(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$4 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$2(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$4 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$4,
  enforce: enforce,
  getterFor: getterFor
};

var DESCRIPTORS$1 = descriptors;
var has$3 = has$7;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$1 && Object.getOwnPropertyDescriptor;

var EXISTS = has$3(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$1 || (DESCRIPTORS$1 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$2 = global$b;
var isCallable$1 = isCallable$9;
var has$2 = has$7;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$3;
var setGlobal$1 = setGlobal$3;
var inspectSource = inspectSource$2;
var InternalStateModule = internalState;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(redefine$1.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$1(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!has$2(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty$1(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$2) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$1(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$1(this) && getInternalState(this).source || inspectSource(this);
});

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger$2 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var toInteger$1 = toInteger$2;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min$1(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger = toInteger$2;

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var toIndexedObject$1 = toIndexedObject$3;
var toLength = toLength$1;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var has$1 = has$7;
var toIndexedObject = toIndexedObject$3;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$1(hiddenKeys$1, key) && has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$1(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$2 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$2;

var hiddenKeys = enumBugKeys$1.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$3;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject = anObject$2;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has = has$7;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$1 = fails$6;
var isCallable = isCallable$9;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails$1(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$1 = global$b;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$3;
var redefine = redefine$1.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$2;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

var DESCRIPTORS = descriptors;
var fails = fails$6;
var objectKeys = objectKeys$1;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$2;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $ = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var clipCorner = {
  disabled: "polygon(0 0, 100% 0, 100% 0, 100% 100%, 0 100%)",
  xs: "polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 0 100%)",
  sm: "polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 0 100%)",
  md: "polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 0 100%)",
  lg: "polygon(0 0, calc(100% - 24px) 0, 100% 24px, 100% 100%, 0 100%)",
  xl: "polygon(0 0, calc(100% - 32px) 0, 100% 32px, 100% 100%, 0 100%)",
  xxl: "polygon(0 0, calc(100% - 48px) 0, 100% 48px, 100% 100%, 0 100%)"
};

// Concrete Light
// The default light palette for the HCSS Concrete design system and theme
var PALETTE_CONCRETE_LIGHT = {
  mode: "light",
  background: {
    "default": "#f0f0f0",
    paper: "#ffffff"
  },

  /** Primary palette: accent blue shades used for key interactive
   *  elements, e.g. buttons, inputs, and links. */
  primary: {
    light: "#ecf5fe",
    main: "#0370f5",
    dark: "#005bca",
    contrastText: "#ffffff"
  },

  /** Secondary palette: alternate, limited grayscale palette for
   *  certain interactive and display elements with low emphasis */
  secondary: {
    light: "#ffffff",
    main: "#f0f0f0",
    dark: "#cccccc",
    contrastText: "#1e1e1e"
  },

  /** Red palette for error states and emphasizing elements with
   *  dangerous or critical actions */
  error: {
    light: "#feeeee",
    main: "#db1010",
    dark: "#9e0a0a",
    contrastText: "#ffffff"
  },

  /** Green palette for success states */
  success: {
    light: "#eefbf5",
    main: "#14af80",
    dark: "#11654d",
    contrastText: "#ffffff"
  },

  /** Amber/yellow palette for warning states */
  warning: {
    light: "#fff2bc",
    main: "#ee6e00",
    dark: "#d47000",
    contrastText: "#ffffff"
  },

  /** Blue palette for informational elements and info states */
  info: {
    light: "#e7f5fb",
    main: "#0370f5",
    dark: "#005bca",
    contrastText: "#ffffff"
  },

  /** Default palette for text */
  text: {
    primary: "#1e1e1e",
    secondary: "#404040",
    disabled: "#707070"
  },

  /** Grayscale palette, used primarily for layout and background
   *  elements */
  grey: {
    50: "#ffffff",
    100: "#f9f9f9",
    200: "#f0f0f0",
    300: "#ececec",
    400: "#d6d6d6",
    500: "#cccccc",
    600: "#aaaaaa",
    700: "#707070",
    800: "#404040",
    900: "#1e1e1e"
  },

  /** Orange palette (part of extended palette definition) */
  orange: {
    50: "#fdf0e0",
    100: "#fbd9b3",
    200: "#f9c080",
    300: "#f6a74d",
    400: "#f49426",
    500: "#f28100",
    600: "#f07900",
    700: "#ee6e00",
    800: "#ec6400",
    900: "#e85100"
  },

  /** Purple palette (part of extended palette definition) */
  purple: {
    50: "#e9e7ff",
    100: "#c8c2ff",
    200: "#a49aff",
    300: "#7f71ff",
    400: "#6352ff",
    500: "#4834ff",
    600: "#3a27ff",
    700: "#2a19f5",
    800: "#2316e5",
    900: "#280ed1"
  },

  /** Bright red color for alert badges, notification counts, etc. */
  alert: "#ff3f1f"
};

var PALETTE_CONCRETE_DARK = Object.assign(Object.assign({}, PALETTE_CONCRETE_LIGHT), {
  mode: "dark"
});

// HCSS Brand Palette
// HCSS product and company brand colors

/** HCSS standard color palette (part of extended palette definition) */
var PALETTE_HCSS_BRANDING = {
  hcssBrandColors: {
    hcssBrandPrimary: "#009639",
    hcssBrandSecondary: "#ffffff",
    heavyBidBrandColor: "#009639",
    heavyJobBrandColor: "#005eb8",
    safetyBrandColor: "#ff9e1b",
    formsBrandColor: "#3e8ede",
    telematicsBrandColor: "#00b5e2",
    plansBrandColor: "#485cc7",
    e360BrandColor: "#007681",
    credentialsBrandColor: "#5f7361",
    driveBrandColor: "#193C6F",
    businessIntelligenceBrandColor: "#193C6F"
  }
};

function getPalette(config) {
  var _config$productColor = config.productColor,
      productColor = _config$productColor === void 0 ? "#009639" : _config$productColor,
      darkMode = config.darkMode; // Use dark palette for dark mode

  if (darkMode) {
    return Object.assign(Object.assign(Object.assign({}, PALETTE_CONCRETE_DARK), PALETTE_HCSS_BRANDING), {
      productColor: productColor
    });
  } // Otherwise, use default light palette


  return Object.assign(Object.assign(Object.assign({}, PALETTE_CONCRETE_LIGHT), PALETTE_HCSS_BRANDING), {
    productColor: productColor
  });
}

var shape = {
  borderRadius: 0
};

/* prettier-ignore */
var spacing = [0, 2, 3, 4, 6, 8, 12, 16, 20, 24, 28, 32, 36, 40, 48, 60, 80, 100, 120, 160, 200 // 20
];

/**
 *  A function that converts a value in px units to a
 *  value in rem units.
 */
function pxToRem(pxValue, htmlFontSize) {
  return pxValue / htmlFontSize + "rem";
}

var FONT_WEIGHT_LIGHT = 200;
var FONT_WEIGHT_REGULAR = 400;
var FONT_WEIGHT_MEDIUM = 600;
var FONT_WEIGHT_BOLD = 800;
function getTypographyBase(baseFontSize) {
  if (baseFontSize === void 0) {
    baseFontSize = 16;
  }

  return {
    fontFamily: "\"Inter\", Helvetica, Arial, sans-serif",
    fontWeightLight: FONT_WEIGHT_LIGHT,
    fontWeightRegular: FONT_WEIGHT_REGULAR,
    fontWeightMedium: FONT_WEIGHT_MEDIUM,
    fontWeightBold: FONT_WEIGHT_BOLD,
    fontFamilyClasses: {
      "default": "\"Inter\", Helvetica, Arial, sans-serif",
      branding: "\"ProximaNova\", Helvetica, Arial, sans-serif",
      brandingBold: "\"ProximaNova Heavy\", Helvetica, Arial Black, sans-serif",
      monospace: "\"JetBrains Mono\", monospace"
    },
    h1: {
      fontSize: pxToRem(28, baseFontSize),
      fontWeight: FONT_WEIGHT_MEDIUM
    },
    h2: {
      fontSize: pxToRem(24, baseFontSize),
      fontWeight: FONT_WEIGHT_MEDIUM
    },
    h3: {
      fontSize: pxToRem(22, baseFontSize),
      fontWeight: FONT_WEIGHT_MEDIUM
    },
    h4: {
      fontSize: pxToRem(20, baseFontSize),
      fontWeight: FONT_WEIGHT_MEDIUM
    },
    h5: {
      fontSize: pxToRem(18, baseFontSize),
      fontWeight: FONT_WEIGHT_REGULAR
    },
    h6: {
      fontSize: pxToRem(16, baseFontSize),
      fontWeight: FONT_WEIGHT_REGULAR
    },
    body1: {
      fontSize: pxToRem(15, baseFontSize),
      fontWeight: "inherit"
    },
    body2: {
      fontSize: pxToRem(14, baseFontSize),
      fontWeight: "inherit"
    }
  };
}

function getTypography(config) {
  var baseFontSize = config.baseFontSize;
  return Object.assign(Object.assign({}, getTypographyBase(baseFontSize)), {
    htmlFontSize: baseFontSize
  });
}

function getAccordionDetailsOverrides(_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      display: "block",
      padding: spacing(0, 8, 9)
    }
  };
}

var expanded$1 = accordionClasses.expanded;
function getAccordionOverrides(_ref) {
  var _root;

  var palette = _ref.palette;
  return {
    root: (_root = {
      boxShadow: "none",
      "&:not(:first-of-type)": {
        borderTop: "1px solid " + palette.grey[300]
      },
      // That thin border underneath the accordion. We'll do that a bit
      // differently.
      "&:before": {
        display: "none"
      }
    }, _root["&." + expanded$1] = {
      margin: 0
    }, _root)
  };
}

var expanded = accordionSummaryClasses.expanded;
function getAccordionSummaryOverrides(_ref) {
  var _root, _content;

  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: (_root = {
      minHeight: "auto",
      padding: spacing(7, 8)
    }, _root["&." + expanded] = {
      minHeight: "auto"
    }, _root),
    content: (_content = {
      margin: 0
    }, _content["&." + expanded] = {
      margin: 0
    }, _content),
    expandIconWrapper: {
      margin: "-" + spacing(7) + " -" + spacing(5) + " -" + spacing(7) + " 0",
      color: palette.grey[600]
    }
  };
}

function getAlertOverrides(_ref) {
  var _standardInfo, _standardWarning, _standardError, _standardSuccess, _root;

  var palette = _ref.palette;
  return {
    standardInfo: (_standardInfo = {
      backgroundColor: palette.info.light,
      border: "1px solid " + palette.info.main + "1e"
    }, _standardInfo["& ." + alertClasses.icon] = {
      color: palette.info.main
    }, _standardInfo),
    standardWarning: (_standardWarning = {
      backgroundColor: lighten(palette.warning.light, 0.4),
      border: "1px solid " + palette.warning.main + "1e"
    }, _standardWarning["& ." + alertClasses.icon] = {
      color: palette.warning.main
    }, _standardWarning),
    standardError: (_standardError = {
      backgroundColor: palette.error.light,
      border: "1px solid " + palette.error.main + "1e"
    }, _standardError["& ." + alertClasses.icon] = {
      color: palette.error.main
    }, _standardError),
    standardSuccess: (_standardSuccess = {
      backgroundColor: palette.success.light,
      border: "1px solid " + palette.success.main + "1e"
    }, _standardSuccess["& ." + alertClasses.icon] = {
      color: palette.success.main
    }, _standardSuccess),
    root: (_root = {}, _root["& ." + alertTitleClasses.root] = {
      marginTop: 0,
      marginBottom: 5
    }, _root)
  };
}

function getAutocompleteOverrides(_ref) {
  var _root;

  var spacing = _ref.spacing;
  return {
    root: (_root = {}, _root["& ." + inputBaseClasses.root + " > ." + inputBaseClasses.input] = {
      padding: "7px " + spacing(3) + " 3px " + spacing(4)
    }, _root),
    endAdornment: {
      top: "calc(50% - " + spacing(6) + ")"
    }
  };
}

function getBadgeOverrides(_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    badge: {
      padding: spacing(0, 3),
      minWidth: "18px",
      height: "18px",
      background: palette.alert,
      color: palette.common.white
    }
  };
}

function getButtonBaseOverrides(_ref) {
  var typography = _ref.typography;
  return {
    root: {
      fontFamily: typography.fontFamilyClasses["default"]
    }
  };
}

function getButtonOverrides(_ref) {
  var spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    root: {
      minHeight: 34,
      padding: spacing(4, 7),
      fontWeight: typography.fontWeightMedium,
      letterSpacing: ".03rem",
      lineHeight: 1.4
    },
    contained: {
      boxShadow: "none"
    },
    text: {
      padding: spacing(4, 6)
    }
  };
}

var checkboxCheckedClasses = {
  root: "CheckboxUncheckedIcon-root",
  boxBackground: "CheckboxUncheckedIcon-boxBackground",
  boxOutline: "CheckboxUncheckedIcon-boxOutline",
  checkSymbol: "CheckboxUncheckedIcon-checkSymbol"
};
function CheckboxChecked(props) {
  return jsxs(SvgIcon, Object.assign({}, props, {
    className: checkboxCheckedClasses.root,
    viewBox: "0 0 24 24"
  }, {
    children: [jsx("rect", {
      className: checkboxCheckedClasses.boxBackground,
      width: "18",
      height: "18",
      stroke: "none",
      fill: "#ffffff",
      strokeWidth: "1",
      transform: "translate(3, 3)"
    }, void 0), jsx("path", {
      className: checkboxCheckedClasses.checkSymbol,
      d: "M21 3H3v18h18V3zM10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
      fill: "currentColor",
      stroke: "none"
    }, void 0), jsx("rect", {
      className: checkboxCheckedClasses.boxOutline,
      x: "0.5",
      y: "0.5",
      width: "17",
      height: "17",
      fill: "none",
      stroke: "none",
      transform: "translate(3, 3)"
    }, void 0)]
  }), void 0);
}

var checkboxUncheckedClasses = {
  root: "CheckboxUncheckedIcon-root",
  boxBackground: "CheckboxUncheckedIcon-boxBackground",
  boxOutline: "CheckboxUncheckedIcon-boxOutline"
};
function CheckboxUnchecked(props) {
  return jsx(SvgIcon, Object.assign({}, props, {
    className: checkboxUncheckedClasses.root,
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      transform: "translate(3, 3)"
    }, {
      children: [jsx("rect", {
        className: checkboxUncheckedClasses.boxBackground,
        width: "18",
        height: "18",
        stroke: "none",
        fill: "#ffffff",
        strokeWidth: "1"
      }, void 0), jsx("rect", {
        className: checkboxUncheckedClasses.boxOutline,
        x: "0.5",
        y: "0.5",
        width: "17",
        height: "17",
        fill: "none",
        stroke: "currentColor"
      }, void 0)]
    }), void 0)
  }), void 0);
}

var checkboxIndeterminateClasses = {
  root: "CheckboxIndeterminateIcon-root",
  boxBackground: "CheckboxIndeterminateIcon-boxBackground",
  boxOutline: "CheckboxIndeterminateIcon-boxOutline",
  minusSymbol: "CheckboxIndeterminateIcon-minusSymbol"
};
function CheckboxIndeterminate(props) {
  return jsxs(SvgIcon, Object.assign({}, props, {
    className: checkboxIndeterminateClasses.root,
    viewBox: "0 0 24 24"
  }, {
    children: [jsx("rect", {
      className: checkboxIndeterminateClasses.boxBackground,
      width: "18",
      height: "18",
      stroke: "none",
      fill: "#ffffff",
      strokeWidth: "1",
      transform: "translate(3, 3)"
    }, void 0), jsx("path", {
      className: checkboxIndeterminateClasses.minusSymbol,
      d: "M21 3H3v18h18V3zm-4 10H7v-2h10v2z",
      fill: "currentColor",
      stroke: "none"
    }, void 0), jsx("rect", {
      className: checkboxIndeterminateClasses.boxOutline,
      x: "0.5",
      y: "0.5",
      width: "17",
      height: "17",
      fill: "none",
      stroke: "none",
      transform: "translate(3, 3)"
    }, void 0)]
  }), void 0);
}

var radioCheckedClasses = {
  root: "RadioCheckedIcon-root",
  radioBackground: "RadioCheckedIcon-radioBackground",
  radioOutline: "RadioCheckedIcon-radioOutline",
  radioInnerDot: "RadioCheckedIcon-innerDot"
};
function RadioChecked(props) {
  return jsx(SvgIcon, Object.assign({}, props, {
    className: radioCheckedClasses.root,
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      transform: "translate(3, 3)"
    }, {
      children: [jsx("circle", {
        className: radioCheckedClasses.radioBackground,
        cx: "9",
        cy: "9",
        r: "9",
        fill: "#ffffff",
        stroke: "none"
      }, void 0), jsx("circle", {
        className: radioCheckedClasses.radioOutline,
        cx: "9",
        cy: "9",
        r: "8",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2"
      }, void 0), jsx("circle", {
        className: radioCheckedClasses.radioInnerDot,
        cx: "9",
        cy: "9",
        r: "4",
        fill: "currentColor",
        stroke: "none"
      }, void 0)]
    }), void 0)
  }), void 0);
}

var radioUncheckedClasses = {
  root: "RadioUncheckedIcon-root",
  radioBackground: "RadioUncheckedIcon-radioBackground",
  radioOutline: "RadioUncheckedIcon-radioOutline"
};
function RadioUnchecked(props) {
  return jsx(SvgIcon, Object.assign({}, props, {
    className: radioUncheckedClasses.root,
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      transform: "translate(3, 3)"
    }, {
      children: [jsx("circle", {
        className: radioUncheckedClasses.radioBackground,
        cx: "9",
        cy: "9",
        r: "9",
        fill: "#ffffff",
        stroke: "none"
      }, void 0), jsx("circle", {
        className: radioUncheckedClasses.radioOutline,
        cx: "9",
        cy: "9",
        r: "8.5",
        fill: "none",
        stroke: "currentColor"
      }, void 0)]
    }), void 0)
  }), void 0);
}

var checked$1 = checkboxClasses.checked,
    disabled$6 = checkboxClasses.disabled,
    indeterminate = checkboxClasses.indeterminate;
var checkedBoxBackground = checkboxCheckedClasses.boxBackground,
    checkedBoxOutline = checkboxCheckedClasses.boxOutline,
    checkedCheckSymbol = checkboxCheckedClasses.checkSymbol;
var uncheckedBoxOutline = checkboxUncheckedClasses.boxOutline;
var indeterminateBoxBackground = checkboxIndeterminateClasses.boxBackground,
    indeterminateBoxOutline = checkboxIndeterminateClasses.boxOutline,
    indeterminateMinusSymbol = checkboxIndeterminateClasses.minusSymbol;
function getCheckboxOverrides(_ref) {
  var _ref2, _ref3, _ref4, _root;

  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: (_root = {
      marginRight: spacing(3),
      padding: spacing(4),
      color: darken(palette.grey[600], 0.1)
    }, _root["&." + disabled$6] = {
      color: palette.grey[600]
    }, _root["&." + checked$1 + "." + disabled$6] = (_ref2 = {}, _ref2["& ." + checkedBoxBackground] = {
      fill: "currentColor",
      filter: "brightness(0.8)"
    }, _ref2["& ." + checkedBoxOutline] = {
      stroke: "currentColor",
      strokeDasharray: "3, 2.5"
    }, _ref2["& ." + checkedCheckSymbol] = {
      fill: palette.common.white
    }, _ref2), _root["&." + indeterminate + "." + disabled$6] = (_ref3 = {}, _ref3["& ." + indeterminateBoxBackground] = {
      fill: "currentColor",
      filter: "brightness(0.8)"
    }, _ref3["& ." + indeterminateBoxOutline] = {
      stroke: "currentColor",
      strokeDasharray: "3, 2.5"
    }, _ref3["& ." + indeterminateMinusSymbol] = {
      fill: palette.common.white
    }, _ref3), _root["&:not(." + checked$1 + ")." + disabled$6] = (_ref4 = {}, _ref4["& ." + uncheckedBoxOutline] = {
      strokeDasharray: "3, 2.5"
    }, _ref4), _root)
  };
}

function getChipOverrides(_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      borderRadius: 2,
      height: 24
    },
    label: {
      paddingLeft: spacing(5),
      paddingRight: spacing(5),
      letterSpacing: ".02em"
    }
  };
}

function getCircularProgressOverrides(_ref) {
  var palette = _ref.palette;
  return {
    indeterminate: {
      color: palette.hcssBrandColors.hcssBrandPrimary
    }
  };
}

function getCssBaselineOverrides(_ref) {
  var typography = _ref.typography;
  return {
    html: {
      background: "none",
      WebkitFontSmoothing: "auto"
    },
    body: {
      background: "none",
      fontFamily: typography.fontFamilyClasses["default"]
    }
  };
}

function getDialogActionsOverrides(_ref) {
  var spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    root: {
      marginTop: spacing(12),
      padding: spacing(0),
      fontSize: typography.pxToRem(13)
    },
    spacing: {
      "& > :not(:first-of-type)": {
        marginLeft: spacing(6)
      }
    }
  };
}

function getDialogContentOverrides(_ref) {
  var spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    root: {
      position: "relative",
      margin: "0 -" + spacing(12),
      padding: spacing(3, 12),
      fontSize: typography.pxToRem(15)
    }
  };
}

function getDialogOverrides(_ref) {
  var spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    paper: {
      position: "relative",
      padding: spacing(10, 12),
      // In some HCSS apps, the conversion to MUI is a gradual process
      // and Bootstrap styles must coexist with the MUI theme (which is
      // "scoped" to a specific part of the DOM). Overlay elements like
      // dialogs, popovers, and tooltips are usually portaled to the
      // document body, where they will be outside of the scoped theme
      // boundary. As a result, such elements will by default use which-
      // ever font is set as the default at the document body.
      //
      // Instead of setting this override to affect all content within
      // the document body, we will simply re-enforce the default font
      // family within the overlay elements (in this case, the dialog),
      // so as not to interfere with Bootstrap components and their
      // styling.
      fontFamily: typography.fontFamilyClasses["default"]
    }
  };
}

function getDialogTitleOverrides(_ref) {
  var spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    root: {
      marginBottom: spacing(8),
      padding: spacing(0),
      fontSize: typography.pxToRem(18),
      fontWeight: 600
    }
  };
}

var formLabelRoot = formLabelClasses.root;
var formControlLabelRoot = formControlLabelClasses.root,
    label = formControlLabelClasses.label;
var inputLabelRoot = inputLabelClasses.root,
    disabled$5 = inputLabelClasses.disabled,
    error$1 = inputLabelClasses.error;
function getFormControlOverrides(_ref) {
  var _ref2, _hover, _root;

  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    root: (_root = {
      marginTop: spacing(5)
    }, _root["& > ." + formLabelRoot + ":not(." + inputLabelRoot + ")"] = {
      marginBottom: spacing(5)
    }, _root["& ." + formControlLabelRoot] = (_ref2 = {
      alignItems: "flex-start"
    }, _ref2["& > ." + label] = {
      marginTop: spacing(5)
    }, _ref2), _root["&:hover"] = (_hover = {}, _hover["& ." + inputLabelRoot + ":not(." + disabled$5 + "):not(." + error$1 + ")"] = {
      color: palette.primary.main
    }, _hover), _root)
  };
}

var disabled$4 = formControlLabelClasses.disabled;
function getFormControlLabelOverrides(_ref) {
  var _root;

  var spacing = _ref.spacing;
  return {
    root: (_root = {
      marginLeft: "calc(-1 * (" + spacing(5) + " + 1px))"
    }, _root["&." + disabled$4] = {
      cursor: "not-allowed"
    }, _root)
  };
}

function getFormGroupOverrides(_ref) {
  var _row;

  var spacing = _ref.spacing;
  return {
    row: (_row = {}, _row["& > ." + formControlLabelClasses.root] = {
      marginRight: spacing(10),
      "&:last-of-type": {
        marginRight: 0
      }
    }, _row)
  };
}

function getFormHelperTextOverrides(_ref) {
  var palette = _ref.palette,
      typography = _ref.typography;
  return {
    root: {
      color: palette.text.disabled,
      fontSize: typography.pxToRem(13.5),
      letterSpacing: ".02rem",
      lineHeight: 1.5
    }
  };
}

function getFormLabelOverrides(_ref) {
  var palette = _ref.palette,
      typography = _ref.typography;
  return {
    root: {
      color: lighten(palette.text.secondary, 0.2),
      fontSize: typography.pxToRem(12),
      fontWeight: typography.fontWeightMedium,
      letterSpacing: ".03rem",
      textTransform: "uppercase"
    }
  };
}

var disabled$3 = inputBaseClasses.disabled;
function getInputBaseOverrides(_ref) {
  var _input;

  var palette = _ref.palette,
      typography = _ref.typography;
  return {
    root: {
      fontSize: typography.pxToRem(16)
    },
    input: (_input = {
      color: palette.grey[800],
      fontSize: typography.pxToRem(15),
      "&:focus": {
        color: palette.grey[900]
      },
      // Hide the default clear button shown in Chrome and
      // some other Webkit browsers
      '&[type="search" i]::-webkit-search-cancel-button': {
        display: "none",
        WebkitAppearance: "none"
      }
    }, _input["&." + disabled$3] = {
      color: palette.text.disabled
    }, _input),
    multiline: {
      padding: 0
    },
    inputMultiline: {
      lineHeight: 1.5
    }
  };
}

var disabled$2 = inputLabelClasses.disabled,
    shrink = inputLabelClasses.shrink;
function getInputLabelOverrides(_ref) {
  var _root, _outlined;

  var spacing = _ref.spacing,
      palette = _ref.palette,
      typography = _ref.typography;
  return {
    root: (_root = {
      fontSize: typography.pxToRem(14),
      fontWeight: typography.fontWeightRegular,
      letterSpacing: ".03em",
      textTransform: "uppercase"
    }, _root["&." + disabled$2] = {
      color: lighten(palette.text.secondary, 0.5)
    }, _root),
    shrink: {
      fontSize: typography.pxToRem(15),
      fontWeight: typography.fontWeightMedium,
      transform: "translate(16px, -8px) scale(.8)"
    },
    outlined: (_outlined = {
      transform: "translate(16px, 15px) scale(1)"
    }, _outlined["&." + shrink] = {
      marginLeft: "-" + spacing(3),
      padding: spacing(0, 3),
      background: "transparent",
      fontSize: typography.pxToRem(15),
      fontWeight: typography.fontWeightMedium,
      letterSpacing: ".03em",
      transform: "translate(16px, -8px) scale(.8)"
    }, _outlined)
  };
}

function getInputOverrides(_ref) {
  var palette = _ref.palette;
  return {
    input: {
      color: palette.grey[800],
      "&:focus": {
        color: palette.grey[900]
      },
      '&[type="search" i]::-webkit-search-cancel-button': {
        display: "none",
        WebkitAppearance: "none"
      }
    }
  };
}

function getLinearProgressOverrides(_ref) {
  var palette = _ref.palette;
  return {
    root: {
      height: 3
    },
    determinate: {
      backgroundColor: palette.grey[300]
    },
    indeterminate: {
      backgroundColor: palette.grey[300]
    }
  };
}

function getLinkOverrides(_ref) {
  var palette = _ref.palette;
  return {
    root: {
      "&, &:hover": {
        color: palette.primary.main
      },
      "&:active, &:active:hover, &:active:focus": {
        color: palette.primary.dark
      }
    }
  };
}

function getListItemAvatarOverrides(_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      paddingRight: spacing(6),
      minWidth: 48
    }
  };
}

function getListItemButtonOverrides(_ref) {
  var _ref2, _root;

  var palette = _ref.palette,
      typography = _ref.typography,
      transitions = _ref.transitions;
  return {
    root: (_root = {}, _root["& ." + touchRippleClasses.root] = {
      opacity: 0.2,
      mixBlendMode: "darken"
    }, _root["& ." + touchRippleClasses.ripple] = {
      color: palette.primary.main,
      mixBlendMode: "darken"
    }, _root["&." + listItemButtonClasses.disabled] = {
      opacity: 0.5
    }, _root["& ." + listItemTextClasses.primary + ",\n        & ." + listItemTextClasses.secondary] = {
      transition: transitions.duration.shorter + "ms"
    }, _root["&." + listItemButtonClasses.selected] = (_ref2 = {}, _ref2["& ." + listItemTextClasses.primary] = {
      fontWeight: typography.fontWeightMedium
    }, _ref2["& ." + listItemTextClasses.secondary] = {
      opacity: 1
    }, _ref2), _root)
  };
}

function getListItemTextOverrides(_ref) {
  var palette = _ref.palette;
  return {
    primary: {
      color: palette.text.primary
    },
    secondary: {
      color: palette.text.secondary,
      opacity: 0.8
    },
    inset: {
      paddingLeft: 48
    }
  };
}

var selected = menuItemClasses.selected;
function getMenuItemOverrides(_ref) {
  var _root;

  var palette = _ref.palette,
      spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    root: (_root = {
      paddingTop: spacing(5),
      paddingBottom: spacing(5),
      padding: spacing(5, 8),
      fontSize: typography.pxToRem(15)
    }, _root["&:hover:not(." + selected + ")"] = {
      background: palette.primary.light,
      color: palette.primary.main
    }, _root["&." + selected] = {
      "&, &:hover, &:active, &:active:hover, &:active:focus": {
        background: palette.primary.main,
        color: palette.common.white
      }
    }, _root)
  };
}

function getMenuOverrides(_ref) {
  var spacing = _ref.spacing;
  return {
    list: {
      padding: spacing(6, 0)
    }
  };
}

var notchedOutline = outlinedInputClasses.notchedOutline,
    disabled$1 = outlinedInputClasses.disabled,
    focused = outlinedInputClasses.focused,
    error = outlinedInputClasses.error;
function getOutlinedInputOverrides(_ref) {
  var _ref2, _hover, _ref3, _root, _hover2, _multiline;

  var spacing = _ref.spacing,
      palette = _ref.palette,
      typography = _ref.typography;
  return {
    root: (_root = {
      position: "relative",
      background: palette.common.white
    }, _root["& ." + notchedOutline] = {
      borderColor: palette.grey[600],
      transition: "0.05s"
    }, _root["&:hover"] = (_hover = {}, _hover[":not(." + disabled$1 + "):not(." + focused + "):not(." + error + ")"] = (_ref2 = {}, _ref2["& ." + notchedOutline] = {
      borderColor: palette.primary.main,
      borderWidth: 2
    }, _ref2), _hover), _root["&." + disabled$1] = (_ref3 = {}, _ref3["& ." + notchedOutline] = {
      borderStyle: "dashed"
    }, _ref3), _root),
    input: {
      padding: spacing(7, 7, 6),
      lineHeight: "normal"
    },
    multiline: (_multiline = {
      padding: 0,
      "&::after": {
        content: "\"\"",
        position: "absolute",
        top: "1px",
        left: spacing(4),
        width: "calc(100% - (" + spacing(7) + " * 2 + 1px))",
        height: spacing(7),
        background: palette.common.white
      },
      "&:hover": (_hover2 = {}, _hover2[":not(." + disabled$1 + ")"] = {
        "&::after": {
          top: "2px",
          height: "calc(" + spacing(7) + " - 1px)"
        }
      }, _hover2)
    }, _multiline["&." + focused] = {
      "&::after": {
        top: "2px",
        height: "calc(" + spacing(7) + " - 1px)"
      }
    }, _multiline),
    inputMultiline: {
      lineHeight: 1.5
    },
    inputAdornedEnd: {
      paddingRight: spacing(3)
    },
    notchedOutline: {
      fontSize: typography.pxToRem(15),
      letterSpacing: ".03em",
      textTransform: "uppercase",
      "& > legend": {
        fontSize: typography.pxToRem(12),
        marginLeft: 1,
        maxWidth: "100%"
      }
    }
  };
}

function getPopoverOverrides(_ref) {
  var spacing = _ref.spacing;
  return {
    paper: {
      marginLeft: spacing(7),
      maxHeight: "calc(100% - 80px)"
    }
  };
}

function getScopedCssBaselineOverrides(_ref) {
  var typography = _ref.typography;
  return {
    root: {
      background: "none",
      fontFamily: typography.fontFamilyClasses["default"],
      WebkitFontSmoothing: "auto"
    }
  };
}

var checked = radioClasses.checked,
    disabled = radioClasses.disabled;
var checkedOutline = radioCheckedClasses.radioOutline;
var uncheckedOutline = radioUncheckedClasses.radioOutline;
function getRadioOverrides(_ref) {
  var _ref2, _ref3, _root;

  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: (_root = {
      padding: spacing(4),
      color: darken(palette.grey[600], 0.2)
    }, _root["&." + disabled] = {
      color: palette.grey[600]
    }, _root["&." + checked + "." + disabled] = (_ref2 = {}, _ref2["& ." + checkedOutline] = {
      strokeDasharray: "3, 2",
      strokeWidth: "1px",
      r: "8.5px"
    }, _ref2), _root["&:not(." + checked + ")." + disabled] = (_ref3 = {}, _ref3["& ." + uncheckedOutline] = {
      strokeDasharray: "3, 2"
    }, _ref3), _root)
  };
}

function getSelectOverrides(_ref) {
  var spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    select: {
      paddingRight: spacing(13) + " !important"
    },
    outlined: {
      paddingRight: spacing(13) + " !important"
    },
    icon: {
      top: "calc(50% - (" + spacing(6) + " - 1px))",
      fontSize: typography.pxToRem(23),
      transition: "0.1s"
    },
    iconOutlined: {
      right: spacing(6)
    }
  };
}

function getSnackbarContentOverrides(_ref) {
  var palette = _ref.palette;
  return {
    root: {
      backgroundColor: palette.grey[900]
    }
  };
}

function getTabOverrides(_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    root: {
      minHeight: 40,
      padding: spacing(4, 8),
      fontSize: typography.pxToRem(15),
      fontWeight: typography.fontWeightRegular,
      lineHeight: 1.5,
      textTransform: "none",
      "&:hover": {
        color: palette.primary.main
      }
    }
  };
}

function getTabsOverrides(_ref) {
  var palette = _ref.palette;
  return {
    root: {
      minHeight: 40,
      borderBottom: "1px solid " + palette.grey[500]
    },
    indicator: {
      height: 3
    }
  };
}

function getTooltipOverrides(_ref) {
  var clipCorner = _ref.clipCorner,
      palette = _ref.palette,
      spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    popper: {
      marginTop: "-" + spacing(4),
      filter: "drop-shadow(0 6px 8px rgba(0, 0, 0, 0.3))",
      opacity: 1
    },
    tooltip: {
      backgroundColor: palette.grey[900],
      padding: spacing(4, 6, 4, 5),
      fontSize: typography.pxToRem(13),
      fontWeight: typography.fontWeightRegular,
      opacity: 1,
      clipPath: clipCorner.sm
    }
  };
}

function getTypographyOverrides(_ref) {
  var spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    root: {
      lineHeight: 1.4
    },
    gutterBottom: {
      marginBottom: spacing(7)
    },
    paragraph: {
      fontSize: typography.body2.fontSize
    },
    subtitle1: {
      fontSize: typography.pxToRem(16),
      fontWeight: "inherit"
    },
    subtitle2: {
      fontSize: typography.pxToRem(13),
      fontWeight: "inherit"
    }
  };
}

var defaultAccordionSummaryProps = {
  expandIcon: jsx(IconButton, {
    children: jsx(ExpandSectionIcon, {}, void 0)
  }, void 0)
};

var defaultBadgeProps = {
  max: 20
};

var defaultButtonProps = {
  variant: "outlined"
};

var defaultCheckboxProps = {
  icon: jsx(CheckboxUnchecked, {}, void 0),
  checkedIcon: jsx(CheckboxChecked, {}, void 0),
  indeterminateIcon: jsx(CheckboxIndeterminate, {}, void 0)
};

function OpenPickerIcon$2() {
  return jsx(CalendarIcon, {
    sx: {
      fontSize: function fontSize(_ref) {
        var typography = _ref.typography;
        return typography.pxToRem(18);
      }
    }
  }, void 0);
}

var defaultDatePickerProps = {
  inputFormat: "MM/DD/YYYY",
  components: {
    OpenPickerIcon: OpenPickerIcon$2
  },
  InputAdornmentProps: {
    sx: {
      marginLeft: 0,
      marginRight: 3
    }
  },
  OpenPickerButtonProps: {
    sx: {
      marginTop: "3px",
      "&:hover": {
        color: function color(_ref2) {
          var palette = _ref2.palette;
          return palette.primary.main;
        }
      }
    }
  }
};

function OpenPickerIcon$1() {
  return jsx(CalendarIcon, {
    sx: {
      fontSize: function fontSize(_ref) {
        var typography = _ref.typography;
        return typography.pxToRem(18);
      }
    }
  }, void 0);
}

var dateRangeIcon = jsx(CalendarIcon, {
  sx: {
    fontSize: function fontSize(_ref2) {
      var typography = _ref2.typography;
      return typography.pxToRem(20);
    }
  }
}, void 0);

var timeIcon = jsx(ClockIcon, {
  sx: {
    fontSize: function fontSize(_ref3) {
      var typography = _ref3.typography;
      return typography.pxToRem(20);
    }
  }
}, void 0);

var defaultDateTimePickerProps = {
  dateRangeIcon: dateRangeIcon,
  timeIcon: timeIcon,
  inputFormat: "MM/DD/YYYY, h:mm a",
  components: {
    OpenPickerIcon: OpenPickerIcon$1
  },
  InputAdornmentProps: {
    sx: {
      marginLeft: 0,
      marginRight: 3
    }
  },
  OpenPickerButtonProps: {
    sx: {
      marginTop: "3px",
      "&:hover": {
        color: function color(_ref4) {
          var palette = _ref4.palette;
          return palette.primary.main;
        }
      }
    }
  }
};

var defaultIconProps = {
  fontSize: "medium"
};

var defaultInputLabelProps = {
  shrink: true
};

var defaultLinkProps = {
  underline: "hover"
};

var defaultRadioProps = {
  icon: jsx(RadioUnchecked, {}, void 0),
  checkedIcon: jsx(RadioChecked, {}, void 0)
};

var defaultSelectProps = {
  IconComponent: ChevronDownIcon
};

function OpenPickerIcon() {
  return jsx(ClockIcon, {
    sx: {
      fontSize: function fontSize(_ref) {
        var typography = _ref.typography;
        return typography.pxToRem(18);
      }
    }
  }, void 0);
}

var defaultTimePickerProps = {
  inputFormat: "h:mm a",
  orientation: "portrait",
  components: {
    OpenPickerIcon: OpenPickerIcon
  },
  InputAdornmentProps: {
    sx: {
      marginLeft: 0,
      marginRight: 3
    }
  },
  OpenPickerButtonProps: {
    sx: {
      marginTop: "3px",
      "&:hover": {
        color: function color(_ref2) {
          var palette = _ref2.palette;
          return palette.primary.main;
        }
      }
    }
  }
};

function getButtonVariants(_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      typography = _ref.typography;
  return [// New variants we introduced
  {
    props: {
      variant: "minimal"
    },
    style: {
      /* This effectively makes minimal-variant buttons as tall as
         the typical <Chip> element. Which is useful, because this
         variant of buttons will often appear next to or near a
        series of chips. */
      minHeight: 24,
      minWidth: "unset",
      padding: spacing(0, 4),
      color: palette.primary.main,
      fontSize: typography.body2.fontSize,
      fontWeight: typography.body2.fontWeight,
      textTransform: "none"
    }
  }, {
    props: {
      variant: "minimal",
      color: "primary"
    },
    style: {
      color: palette.primary.main
    }
  }, {
    props: {
      variant: "minimal",
      color: "error"
    },
    style: {
      color: palette.error.main
    }
  }, {
    props: {
      variant: "minimal",
      color: "warning"
    },
    style: {
      color: palette.warning.main
    }
  }, {
    props: {
      variant: "minimal",
      color: "success"
    },
    style: {
      color: palette.success.main
    }
  }, {
    props: {
      variant: "minimal",
      color: "info"
    },
    style: {
      color: palette.info.main
    }
  }, {
    props: {
      variant: "minimal",
      color: "secondary"
    },
    style: {
      color: palette.text.primary
    }
  }, // Existing MUI-provided variants that needed some tweaking
  {
    props: {
      variant: "outlined",
      color: "secondary"
    },
    style: {
      borderColor: palette.grey[600],
      color: palette.text.primary,
      "&:hover": {
        background: palette.grey[100],
        borderColor: palette.grey[700]
      }
    }
  }, {
    props: {
      variant: "text",
      color: "secondary"
    },
    style: {
      color: palette.text.primary,
      "&:hover": {
        background: palette.grey[100]
      }
    }
  }];
}

function getComponentDefaults(themeSettings) {
  return {
    MuiAccordionDetails: {
      styleOverrides: getAccordionDetailsOverrides(themeSettings)
    },
    MuiAccordion: {
      styleOverrides: getAccordionOverrides(themeSettings)
    },
    MuiAccordionSummary: {
      defaultProps: defaultAccordionSummaryProps,
      styleOverrides: getAccordionSummaryOverrides(themeSettings)
    },
    MuiAlert: {
      styleOverrides: getAlertOverrides(themeSettings)
    },
    MuiAutocomplete: {
      styleOverrides: getAutocompleteOverrides(themeSettings)
    },
    MuiBadge: {
      defaultProps: defaultBadgeProps,
      styleOverrides: getBadgeOverrides(themeSettings)
    },
    MuiButtonBase: {
      styleOverrides: getButtonBaseOverrides(themeSettings)
    },
    MuiButton: {
      defaultProps: defaultButtonProps,
      styleOverrides: getButtonOverrides(themeSettings),
      variants: getButtonVariants(themeSettings)
    },
    MuiCheckbox: {
      defaultProps: defaultCheckboxProps,
      styleOverrides: getCheckboxOverrides(themeSettings)
    },
    MuiChip: {
      styleOverrides: getChipOverrides(themeSettings)
    },
    MuiCircularProgress: {
      styleOverrides: getCircularProgressOverrides(themeSettings)
    },
    MuiCssBaseline: {
      styleOverrides: getCssBaselineOverrides(themeSettings)
    },
    MuiDatePicker: {
      defaultProps: defaultDatePickerProps
    },
    MuiDateTimePicker: {
      defaultProps: defaultDateTimePickerProps
    },
    MuiDesktopTimePicker: {
      defaultProps: defaultTimePickerProps
    },
    MuiDialogActions: {
      styleOverrides: getDialogActionsOverrides(themeSettings)
    },
    MuiDialogContent: {
      styleOverrides: getDialogContentOverrides(themeSettings)
    },
    MuiDialog: {
      styleOverrides: getDialogOverrides(themeSettings)
    },
    MuiDialogTitle: {
      styleOverrides: getDialogTitleOverrides(themeSettings)
    },
    MuiFormControl: {
      styleOverrides: getFormControlOverrides(themeSettings)
    },
    MuiFormControlLabel: {
      styleOverrides: getFormControlLabelOverrides(themeSettings)
    },
    MuiFormGroup: {
      styleOverrides: getFormGroupOverrides(themeSettings)
    },
    MuiFormHelperText: {
      styleOverrides: getFormHelperTextOverrides(themeSettings)
    },
    MuiFormLabel: {
      styleOverrides: getFormLabelOverrides(themeSettings)
    },
    MuiIcon: {
      defaultProps: defaultIconProps
    },
    MuiInputBase: {
      styleOverrides: getInputBaseOverrides(themeSettings)
    },
    MuiInputLabel: {
      defaultProps: defaultInputLabelProps,
      styleOverrides: getInputLabelOverrides(themeSettings)
    },
    MuiInput: {
      styleOverrides: getInputOverrides(themeSettings)
    },
    MuiLinearProgress: {
      styleOverrides: getLinearProgressOverrides(themeSettings)
    },
    MuiLink: {
      defaultProps: defaultLinkProps,
      styleOverrides: getLinkOverrides(themeSettings)
    },
    MuiListItemAvatar: {
      styleOverrides: getListItemAvatarOverrides(themeSettings)
    },
    MuiListItemButton: {
      styleOverrides: getListItemButtonOverrides(themeSettings)
    },
    MuiListItemText: {
      styleOverrides: getListItemTextOverrides(themeSettings)
    },
    MuiMenuItem: {
      styleOverrides: getMenuItemOverrides(themeSettings)
    },
    MuiMenu: {
      styleOverrides: getMenuOverrides(themeSettings)
    },
    MuiOutlinedInput: {
      styleOverrides: getOutlinedInputOverrides(themeSettings)
    },
    MuiPopover: {
      styleOverrides: getPopoverOverrides(themeSettings)
    },
    MuiRadio: {
      defaultProps: defaultRadioProps,
      styleOverrides: getRadioOverrides(themeSettings)
    },
    MuiScopedCssBaseline: {
      styleOverrides: getScopedCssBaselineOverrides(themeSettings)
    },
    MuiSelect: {
      defaultProps: defaultSelectProps,
      styleOverrides: getSelectOverrides(themeSettings)
    },
    MuiSnackbarContent: {
      styleOverrides: getSnackbarContentOverrides(themeSettings)
    },
    MuiTab: {
      styleOverrides: getTabOverrides(themeSettings)
    },
    MuiTabs: {
      styleOverrides: getTabsOverrides(themeSettings)
    },
    MuiTooltip: {
      styleOverrides: getTooltipOverrides(themeSettings)
    },
    MuiTypography: {
      styleOverrides: getTypographyOverrides(themeSettings)
    }
  };
}

/** A hook that generates a Material-UI theme */

function useThemeBuilder(config) {
  var productColor = config.productColor,
      darkMode = config.darkMode,
      highContrast = config.highContrast,
      baseFontSize = config.baseFontSize; // Build palette settings

  var palette = useMemo(function () {
    return getPalette({
      productColor: productColor,
      darkMode: darkMode,
      highContrast: highContrast
    });
  }, [productColor, darkMode, highContrast]); // Build typography settings

  var typography = useMemo(function () {
    return getTypography({
      baseFontSize: baseFontSize
    });
  }, [baseFontSize]); // building a base theme first so that it can be referenced in component overrides
  // https://stackoverflow.com/questions/57630926/material-ui-theme-overrides-leveraging-theme-palette-colors?rq=1

  var baseTheme = useMemo(function () {
    return createTheme({
      palette: palette,
      shape: shape,
      spacing: spacing,
      typography: typography
    });
  }, [palette, typography]); // Build component defaults and overrides

  var components = useMemo(function () {
    return getComponentDefaults({
      clipCorner: clipCorner,
      palette: baseTheme.palette,
      spacing: baseTheme.spacing,
      typography: baseTheme.typography,
      transitions: baseTheme.transitions
    });
  }, [baseTheme]);
  return Object.assign(Object.assign({}, createTheme({
    palette: palette,
    shape: shape,
    spacing: spacing,
    typography: typography,
    components: components
  })), {
    clipCorner: clipCorner
  });
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$1;
var fonts = css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  @import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&display=swap\");\n  @import url(\"https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;800&display=swap\");\n\n  /*\n   * ProximaNova font (licensed, via CDN)\n   */\n  @font-face {\n    font-family: \"ProximaNova\";\n    src: url(\"https://hcss-styleguide.azureedge.net/fonts/325069_6_0.eot\");\n    src: url(\"https://hcss-styleguide.azureedge.net/fonts/325069_6_0.eot\")\n        format(\"embedded-opentype\"),\n      url(\"https://hcss-styleguide.azureedge.net/fonts/325069_6_0.woff2\")\n        format(\"woff2\"),\n      url(\"https://hcss-styleguide.azureedge.net/fonts/325069_6_0.woff\")\n        format(\"woff\"),\n      url(\"https://hcss-styleguide.azureedge.net/fonts/325069_6_0.ttf\")\n        format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  /*\n   * ProximaNova Heavy font (licensed, via CDN)\n   */\n  @font-face {\n    font-family: \"ProximaNova Heavy\";\n    src: url(\"https://hcss-styleguide.azureedge.net/fonts/325069_2_0.eot\");\n    src: url(\"https://hcss-styleguide.azureedge.net/fonts/325069_2_0.eot\")\n        format(\"embedded-opentype\"),\n      url(\"https://hcss-styleguide.azureedge.net/fonts/325069_2_0.woff2\")\n        format(\"woff2\"),\n      url(\"https://hcss-styleguide.azureedge.net/fonts/325069_2_0.woff\")\n        format(\"woff\"),\n      url(\"https://hcss-styleguide.azureedge.net/fonts/325069_2_0.ttf\")\n        format(\"truetype\");\n    font-weight: bold;\n  }\n"])));

var _templateObject;
/**
 *  It is not possible to pass style overrides to the
 *  Popper component and inner components of the popover
 *  used by MUI Pickers via component props method due to
 *  some known bugs and limitations:
 *  - https://github.com/mui-org/material-ui/issues/27703
 *  - https://github.com/mui-org/material-ui/issues/27681
 *  - https://github.com/mui-org/material-ui/issues/28711
 *  As a result, these global style rules will have to do
 *  the job for now
 */

var nonStandardOverrides = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  /* * * * * * *  DATE, TIME, AND DATE-TIME PICKERS * * * * * * */\n  /* * * * * * *  TIME PICKERS * * * * * * */\n  .MuiTimePicker-popper {\n    background-color: none;\n    font-family: \"Inter\", Arial, Helvetica, sans-serif;\n  }\n  .MuiTimePicker-popper > div[tabIndex=\"-1\"] {\n    padding: 24px 28px;\n  }\n  .MuiTimePicker-popper\n    > div[tabIndex=\"-1\"]\n    button:not([title*=\"previous\"]):not([title*=\"next\"]) {\n    border-radius: 0;\n    padding: 12px;\n  }\n  .MuiTimePicker-popper\n    > div[tabIndex=\"-1\"]\n    button:not([title*=\"previous\"]):not([title*=\"next\"]):not(:last-child) {\n    margin: 0 0 6px 8px;\n  }\n  .MuiTimePicker-popper\n    > div[tabIndex=\"-1\"]\n    button:not([title*=\"previous\"]):not([title*=\"next\"]):last-child {\n    margin: 0 8px 6px 0;\n  }\n  .MuiTimePicker-popper\n    > div[tabIndex=\"-1\"]\n    button:not([title*=\"previous\"]):not([title*=\"next\"])::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #0370f5;\n    opacity: 0;\n  }\n  .MuiTimePicker-popper\n    > div[tabIndex=\"-1\"]\n    button:not([title*=\"previous\"]):not([title*=\"next\"]):hover {\n    color: #0370f5;\n  }\n  .MuiTimePicker-popper\n    > div[tabIndex=\"-1\"]\n    button:not([title*=\"previous\"]):not([title*=\"next\"]):hover::after {\n    opacity: 0.2;\n  }\n  .MuiTimePicker-popper\n    > div[tabIndex=\"-1\"]\n    button:not([title*=\"previous\"]):not([title*=\"next\"])\n    > span {\n    font-weight: 600;\n  }\n\n  /* * * * * * *  DATE TIME PICKERS * * * * * * */\n  .MuiDateTimePicker-popper {\n    background-color: none;\n    font-family: \"Inter\", Arial, Helvetica, sans-serif;\n  }\n  .MuiDateTimePicker-popper > div[tabIndex=\"-1\"] button[role=\"tab\"] {\n    padding: 12px 20px;\n  }\n  .MuiDateTimePicker-popper.MuiDateTimePicker-time-selection\n    > div[tabIndex=\"-1\"] {\n    padding: 24px 28px;\n  }\n  .MuiDateTimePicker-popper.MuiDateTimePicker-time-selection\n    > div[tabIndex=\"-1\"]\n    > div\n    > div:first-of-type {\n    margin: 24px -28px -24px;\n  }\n  .MuiDateTimePicker-popper.MuiDateTimePicker-time-selection\n    > div[tabIndex=\"-1\"]\n    button:not([role=\"tab\"]):not([title*=\"previous\"]):not([title*=\"next\"]) {\n    border-radius: 0;\n    padding: 12px;\n  }\n  .MuiDateTimePicker-popper.MuiDateTimePicker-time-selection\n    > div[tabIndex=\"-1\"]\n    button:not([role=\"tab\"]):not([title*=\"previous\"]):not([title*=\"next\"]):not(:last-child) {\n    margin: 0 0 6px 8px;\n  }\n\n  .MuiDateTimePicker-popper.MuiDateTimePicker-time-selection\n    > div[tabIndex=\"-1\"]\n    button:not([role=\"tab\"]):not([title*=\"previous\"]):not([title*=\"next\"]):last-child {\n    margin: 0 8px 6px 0;\n  }\n  .MuiDateTimePicker-popper.MuiDateTimePicker-time-selection\n    > div[tabIndex=\"-1\"]\n    button:not([role=\"tab\"]):not([title*=\"previous\"]):not([title*=\"next\"]):last-child {\n    margin: 0 8px 6px 0;\n  }\n  .MuiDateTimePicker-popper.MuiDateTimePicker-time-selection\n    > div[tabIndex=\"-1\"]\n    div\n    > div:first-of-type\n    > span.", " {\n    margin: 0 8px 6px 0;\n  }\n  .MuiDateTimePicker-popper.MuiDateTimePicker-time-selection\n    > div[tabIndex=\"-1\"]\n    button:not([role=\"tab\"]):not([title*=\"previous\"]):not([title*=\"next\"])::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #0370f5;\n    opacity: 0;\n  }\n  .MuiDateTimePicker-popper.MuiDateTimePicker-time-selection\n    > div[tabIndex=\"-1\"]\n    button:not([role=\"tab\"]):not([title*=\"previous\"]):not([title*=\"next\"]):hover {\n    color: #0370f5;\n  }\n  .MuiDateTimePicker-popper.MuiDateTimePicker-time-selection\n    > div[tabIndex=\"-1\"]\n    button:not([role=\"tab\"]):not([title*=\"previous\"]):not([title*=\"next\"]):hover::after {\n    opacity: 0.2;\n  }\n  .MuiDateTimePicker-popper.MuiDateTimePicker-time-selection\n    > div[tabIndex=\"-1\"]\n    button:not([role=\"tab\"]):not([title*=\"previous\"]):not([title*=\"next\"])\n    > span {\n    font-weight: 600;\n  }\n"])), typographyClasses.caption);

function GlobalOverrides() {
  return jsxs(Fragment, {
    children: [jsx(Global, {
      styles: fonts
    }, void 0), jsx(Global, {
      styles: nonStandardOverrides
    }, void 0)]
  }, void 0);
}

/** Mount this theme provider wrapper at the very top of your ReactDOM tree
 *  to apply the base CSS reset, Material UI theme, and custom overrides
 *  defined for our UI components. */

function ThemeProvider(props) {
  var _props$scoped = props.scoped,
      scoped = _props$scoped === void 0 ? false : _props$scoped,
      children = props.children,
      config = __rest(props, ["scoped", "children"]);

  var theme = useThemeBuilder(Object.assign({}, config));

  function renderGlobalBaseline() {
    if (!scoped) return jsx(Baseline, {}, void 0);
    return null;
  }

  function renderContent() {
    if (scoped) {
      return jsx(ScopedBaseline, {
        children: children
      }, void 0);
    }

    return children;
  }

  return jsx(StyledEngineProvider, Object.assign({
    injectFirst: true
  }, {
    children: jsxs(ThemeProvider$1, Object.assign({
      theme: theme
    }, {
      children: [jsx(GlobalOverrides, {}, void 0), renderGlobalBaseline(), renderContent()]
    }), void 0)
  }), void 0);
}

/** A wrapper around the Material UI `useTheme` hook which exposes
 *  the hcss augmented theme object with additional palette options
 *  and useful standardized properties that don't exist on the base
 *  Material UI theme object */

function useTheme() {
  return useTheme$1();
}

export { ThemeProvider, useTheme, useThemeBuilder };
